// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

import { FormSection } from "components/ratecard/_common";
import { useEditServiceContext, useRateCardContext } from "components/ratecard/contextProviders";
import { getCurrencyByCountry } from "helperFunctions/_common/getCurrencyByCountry";

import { EditInline } from "./EditInline";
import { Preview } from "./Preview";

export const StorageSection = () => {
  const name = ["storage"];
  const { allowEditing: isAllowEditing } = useEditServiceContext();
  const { activeZone } = useRateCardContext();

  const currency: string = getCurrencyByCountry(activeZone?.facility?.country || "");

  return (
    <FormSection title="Storage Fee">
      {isAllowEditing ? <EditInline name={name} currency={currency} /> : <Preview name={name} currency={currency} />}
    </FormSection>
  );
};
